var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "bulma-table",
    {
      staticClass: "table is-bordered is-striped is-narrow is-fullwidth",
      attrs: {
        columns: _vm.columns,
        "page-index": _vm.filter.pageIndex,
        "page-size": _vm.filter.pageSize,
        "total-rows": _vm.totalRows,
        "is-loading": _vm.isTableLoading,
        "sort-column": _vm.filter.sortColumn,
        "sort-order": _vm.filter.sortOrder,
        "show-header": true,
      },
      on: { pageChanged: _vm.onPageChange, sort: _vm.sort },
    },
    [
      _vm._l(_vm.messages, function (message, index) {
        return _c(
          "tr",
          {
            key: message.messageId,
            on: {
              click: function ($event) {
                return _vm.highlightSelected(index, $event)
              },
            },
          },
          [
            _c("td", [
              _vm._v(" " + _vm._s(message.messageTypeDescription) + " "),
              message.messageDirection === 0
                ? _c(
                    "span",
                    {
                      staticClass: "tooltip is-tooltip-topleft",
                      attrs: { "data-tooltip": "Inbound" },
                    },
                    [
                      _c("i", {
                        staticClass:
                          "mdi mdi-arrow-down-thick has-text-success",
                      }),
                    ]
                  )
                : _c(
                    "span",
                    {
                      staticClass: "tooltip is-tooltip-topleft",
                      attrs: { "data-tooltip": "Outbound" },
                    },
                    [
                      _c("i", {
                        staticClass: "mdi mdi-arrow-up-thick has-text-danger",
                      }),
                    ]
                  ),
            ]),
            _vm.messageType !== "EstImage" && _vm.messageType !== "audanet"
              ? _c("td", [_vm._v(" " + _vm._s(message.qdeStatus) + " ")])
              : _vm._e(),
            _vm.messageType == "audanet"
              ? _c("td", [_vm._v(" " + _vm._s(message.status) + " ")])
              : _vm._e(),
            _vm.messageType !== "EstImage" && _vm.messageType !== "audanet"
              ? _c("td", [_vm._v(" " + _vm._s(message.messageNo) + " ")])
              : _vm._e(),
            _c("td", { staticClass: "has-text-right" }, [
              _vm._v(" " + _vm._s(message.quoteNo) + " "),
            ]),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.$filters.formatDateTimeLocale(
                      message.createdDate,
                      _vm.$userInfo.locale
                    )
                  ) +
                  " "
              ),
            ]),
            _c("td", { staticClass: "is-content-width has-text-centered" }, [
              _c(
                "a",
                {
                  staticClass:
                    "button is-primary is-small is-inverted tooltip is-tooltip-topright",
                  attrs: { "data-tooltip": "Click to view" },
                  on: {
                    click: function ($event) {
                      return _vm.viewXml(message.messageId)
                    },
                  },
                },
                [
                  _c("span", { staticClass: "icon is-medium" }, [
                    _c("i", { staticClass: "mdi mdi-file-find mdi-24px" }),
                  ]),
                ]
              ),
            ]),
          ]
        )
      }),
      _c("template", { slot: "empty" }, [
        _c("section", { staticClass: "section" }, [
          _c(
            "div",
            { staticClass: "content has-text-grey has-text-centered" },
            [
              _c("span", { attrs: { icon: "icon is-large" } }, [
                _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
              ]),
              _c("p", [_vm._v("Nothing")]),
            ]
          ),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }